import { APP_ROUTES } from "../../constants/global.constants";

export const PAGE_NAVIGATION_KEYS = {
  PLANT_SETUP: "plant_setup",
  DATA_UPLOAD: "data_upload",
  SELECT_ADVISOR: "select_advisor",
};

export const PLANT_SETUP_NAVIGATION_PAGES = [
  {
    key: "plant_setup",
    labelKey: "pageNavigation.plantSetup",
    previousLabelKey: "ValueStrings.saveExit",
    nextLabelKey: "ValueStrings.saveContinue",
    path: `/${APP_ROUTES.EDIT_PLANT}`,
    aliasPath: `/${APP_ROUTES.ADD_PLANT}`,
    queryParams: {
      isEdit: "true",
    },
    sequence: 1,
    minWidth: 138,
  },
  {
    key: "data_upload",
    labelKey: "pageNavigation.dataUpload",
    previousLabelKey: "pageNavigation.plantSetup",
    nextLabelKey: "analyseData.proceedtoAnalysis",
    path: `/${APP_ROUTES.ANALYSE_DATA}`,
    sequence: 2,
    minWidth: 137,
  },
  {
    key: "select_advisor",
    labelKey: "pageNavigation.selectAdvisor",
    previousLabelKey: "pageNavigation.dataUpload",
    nextLabelKey: "pageNavigation.cleaningAdvisor",
    path: `/${APP_ROUTES.HOME}`,
    sequence: 3,
    minWidth: 181,
  },
];

// If a step omits previousLabelKey/nextLabelKey, the ribbon falls back to Back and Next.
export const CLEANING_ADVISOR_NAVIGATION_PAGES = [
  {
    key: "cleaning_summary",
    labelKey: "pageNavigation.systemInformation",
    sequence: 1,
  },
  {
    key: "identify_cip",
    labelKey: "pageNavigation.identifyCIP",
    sequence: 2,
  },
  {
    key: "cleaning_effectiveness",
    labelKey: "pageNavigation.cleaningEffectiveness",
    sequence: 3,
  },
  {
    key: "fouling",
    labelKey: "pageNavigation.fouling",
    sequence: 4,
  },
  {
    key: "predict",
    labelKey: "pageNavigation.predict",
    nextLabelKey: "appHome.roReplacementAdvisor",
    sequence: 5,
  },
];

export const LIFETIME_ADVISOR_NAVIGATION_PAGES = [
  {
    key: "lifetime_summary",
    labelKey: "pageNavigation.systemInformation",
    sequence: 1,
  },
  {
    key: "forecast",
    labelKey: "pageNavigation.identifyForecast",
    nextLabelKey: "appHome.roAdvisor",
    sequence: 2,
  },
];

export const NAVIGATION_PAGES_TO_PATH_MAP = {
  [APP_ROUTES.ADD_PLANT]: PLANT_SETUP_NAVIGATION_PAGES,
  [APP_ROUTES.EDIT_PLANT]: PLANT_SETUP_NAVIGATION_PAGES,
  [APP_ROUTES.ANALYSE_DATA]: PLANT_SETUP_NAVIGATION_PAGES,
  [APP_ROUTES.HOME]: PLANT_SETUP_NAVIGATION_PAGES,
  [APP_ROUTES.CLEANING_ADVISOR_HOME]: CLEANING_ADVISOR_NAVIGATION_PAGES,
  [APP_ROUTES.LIFETIME_ADVISOR_HOME]: LIFETIME_ADVISOR_NAVIGATION_PAGES,
};
